import Colors from '../../../../Configs/colors';

const styles = {
  boxes: {
    '& .storage': {
      height: 40,
      width: 40,
      borderRadius: 8,
      boxSizing: 'border-box',
      '&.available': {
        background: '#7ccfbd',
      },
      '&.not_available': {
        background: Colors.primary,
      },
      '&.empty': {
        background: '#ECF5F8',
        border: '1px solid #022E39',
        '&.selected': {
          background: '#E87A46',
          border: '2px solid #BB6238',
        },
      },
      '&.pointer': {
        cursor: 'pointer',
      },
    },
  },
  root: {
    paddingBottom: 24,
    '& .info-card': {
      background: Colors.white,
      padding: 16,
      borderRadius: 8,
      boxShadow: '2px 3px 6px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.02)',
      '& .status': {
        background: '#ECF5F8',
        fontSize: 14,
        padding: '4px 12px',
        borderRadius: 25,
        color: '#282828',
        fontWeight: '500',
      },
    },
    '& .action': {
      minWidth: 200,
    },
    '& .plan': {
      background: '#ECF5F8',
      padding: '2px 8px 2px 2px',
      borderRadius: 25,
    },
    '& .stepper': {
      borderLeft: '',
    },
  },
};

export default styles;
